export default [
  {
    name: 'getUserPage-xbw',
    method: 'POST',
    path: '/vue/imhx/hxuser-page-enable'
  },
  {
    name: 'addUser-xbw',
    method: 'POST',
    path: '/vue/imhx/hxuser-register'
  }
];
